var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.SelectCopyContent"),
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("div", [
        _c("fieldset", [
          _c("legend", [_vm._v(_vm._s(_vm.$t("Message.CopyContent")))]),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-direction": "column",
                "padding-left": "30px"
              }
            },
            [
              _c(
                "el-checkbox",
                {
                  attrs: { disabled: true },
                  model: {
                    value: _vm.basicInfo,
                    callback: function($$v) {
                      _vm.basicInfo = $$v
                    },
                    expression: "basicInfo"
                  }
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.lob === "AI" && _vm.isMaster
                        ? _vm.$t("SeaExport.MblInfo")
                        : _vm.$t("SeaExport.BasicInfo")
                    )
                  )
                ]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lob === "SE",
                      expression: "lob === 'SE'"
                    }
                  ],
                  model: {
                    value: _vm.booking,
                    callback: function($$v) {
                      _vm.booking = $$v
                    },
                    expression: "booking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Booking")))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isMaster && _vm.lob === "SE",
                      expression: "!isMaster && lob === 'SE'"
                    }
                  ],
                  model: {
                    value: _vm.prePlanBooking,
                    callback: function($$v) {
                      _vm.prePlanBooking = $$v
                    },
                    expression: "prePlanBooking"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.prePlanBooking")))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.lob === "SE" ||
                        _vm.lob === "SI" ||
                        _vm.lob === "AE",
                      expression: "lob === 'SE' || lob === 'SI' || lob === 'AE'"
                    }
                  ],
                  attrs: { disabled: _vm.mblEnable },
                  model: {
                    value: _vm.mbl,
                    callback: function($$v) {
                      _vm.mbl = $$v
                    },
                    expression: "mbl"
                  }
                },
                [_vm._v(_vm._s(_vm.lob === "AE" ? "MAWB" : "MBL"))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.isMaster &&
                        (_vm.lob === "SE" ||
                          _vm.lob === "SI" ||
                          _vm.lob === "AE"),
                      expression:
                        "!isMaster && (lob === 'SE' || lob === 'SI' || lob === 'AE')"
                    }
                  ],
                  attrs: { disabled: _vm.hblEnable },
                  model: {
                    value: _vm.hbl,
                    callback: function($$v) {
                      _vm.hbl = $$v
                    },
                    expression: "hbl"
                  }
                },
                [_vm._v(_vm._s(_vm.lob === "AE" ? "HAWB" : "HBL"))]
              ),
              _c(
                "el-checkbox",
                {
                  model: {
                    value: _vm.charge,
                    callback: function($$v) {
                      _vm.charge = $$v
                    },
                    expression: "charge"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Charge")))]
              ),
              _c(
                "el-checkbox",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.lob === "IE" && _vm.containerLoadType === "TT",
                      expression: "lob === 'IE' && containerLoadType === 'TT'"
                    }
                  ],
                  model: {
                    value: _vm.truckingInfo,
                    callback: function($$v) {
                      _vm.truckingInfo = $$v
                    },
                    expression: "truckingInfo"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.GatheringTrailer")))]
              )
            ],
            1
          )
        ]),
        _vm.lob === "SE" ||
        _vm.lob === "SI" ||
        _vm.lob === "AE" ||
        _vm.lob === "AI" ||
        _vm.lob === "RE" ||
        _vm.lob === "RI" ||
        _vm.lob === "IE" ||
        _vm.lob === "remoteBooking"
          ? _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "flex-direction": "row",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "el-checkbox",
                  {
                    staticStyle: {
                      "margin-top": "8px",
                      "margin-bottom": "8px",
                      "word-wrap": "break-word",
                      "white-space": "normal",
                      "word-break": "normal",
                      display: "flex",
                      "flex-direction": "row",
                      "justify-content": "center"
                    },
                    model: {
                      value: _vm.notMatchAgainSelect,
                      callback: function($$v) {
                        _vm.notMatchAgainSelect = $$v
                      },
                      expression: "notMatchAgainSelect"
                    }
                  },
                  [
                    _c("span", { staticStyle: { "font-size": "12px" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("queryJob.WhenDepartmentBranchNewSelection")
                        )
                      )
                    ])
                  ]
                )
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "align-items": "center"
            }
          },
          [
            _c(
              "el-checkbox",
              {
                staticStyle: {
                  "margin-top": "8px",
                  "margin-bottom": "8px",
                  "word-wrap": "break-word",
                  "white-space": "normal",
                  "word-break": "normal",
                  display: "flex",
                  "flex-direction": "row",
                  "justify-content": "center"
                },
                model: {
                  value: _vm.rmb,
                  callback: function($$v) {
                    _vm.rmb = $$v
                  },
                  expression: "rmb"
                }
              },
              [
                _c("span", { staticStyle: { "font-size": "12px" } }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "SeaExport.ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskLeft"
                      )
                    )
                  )
                ])
              ]
            )
          ],
          1
        ),
        _c(
          "div",
          {
            staticStyle: {
              "word-wrap": "break-word",
              "white-space": "normal",
              "font-family": "sans-serif",
              "margin-bottom": "8px",
              "margin-left": "24px"
            }
          },
          [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "10px",
                  color: "#8c939d",
                  "line-height": "18px"
                }
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "SeaExport.ByThisTimeAfterSelectingTheCopiedWithoutHavingToAskRight"
                    )
                  )
                )
              ]
            )
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.showCopyNumber &&
                  (_vm.lob === "SE" || _vm.lob === "AI" || "AE" || "SI"),
                expression:
                  "showCopyNumber && (lob === 'SE' || lob==='AI' || 'AE' || 'SI')"
              }
            ],
            staticStyle: {
              "margin-left": "24px",
              "font-size": "12px",
              "-webkit-font-smoothing": "antialiased",
              "text-rendering": "optimizeLegibility",
              "font-family":
                "Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif"
            }
          },
          [
            _c("label", [_vm._v(_vm._s(_vm.$t("Message.CopyNumber")))]),
            _c("el-input-number", {
              staticStyle: { width: "100px" },
              attrs: {
                value: _vm.copyNum,
                precision: 0,
                min: 1,
                max: 100,
                "controls-position": "right"
              },
              on: { input: _vm.numFunction }
            })
          ],
          1
        )
      ]),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "confirm", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }